import type { Signer } from "../type";

type SignerSlot = {
  position: number;
  primary: Signer | null;
  backup: Signer | null;
};

export const groupSignersByPosition = (
  signers?: Signer[] | null,
): SignerSlot[] => {
  if (!Array.isArray(signers) || signers.length === 0) return [];

  const map = new Map<number, SignerSlot>();

  for (const signer of signers) {
    const pos = signer?.pivot?.position;
    const type = signer?.pivot?.type;

    if (!map.has(pos)) {
      map.set(pos, {
        position: pos,
        primary: null,
        backup: null,
      });
    }

    const slot = map.get(pos);

    if (type === "required" && slot) {
      slot.primary = signer;
    } else if (type === "optional" && slot) {
      slot.backup = signer;
    }
  }

  return Array.from(map.values()).sort((a, b) => a.position - b.position);
};
